module.exports = __webpack_public_path__ + "static/PAST EVENTS-9e0d4369cf2804c49d2a39c0f7551e47.svg";